import { Injectable } from '@angular/core';

import {
  StateDeclaration,
  Transition,
  TargetState } from '@uirouter/angular';
import { lastValueFrom } from 'rxjs';
import { PreferencesService } from '@tdwb/core';

@Injectable({
  providedIn: 'root'
})
export class LtiRouterStateRedirectingService {

  constructor(private preferencesService: PreferencesService) {
  }

  getRedirectStateIfNeeded(transition: Transition): Promise<boolean | TargetState> {
    const toState: StateDeclaration = transition.to();
    return lastValueFrom(this.preferencesService.getUserPreference<boolean>('HAS_EVER_CREATED_GOAL'))
      .then((hasGoalEverBeenCreated: boolean): boolean | TargetState => {
        let stateName;
        if (hasGoalEverBeenCreated === true) {
          stateName =  toState.data && toState.data.ltiWelcomePage === true ? 'page.lti.dashboard' : undefined;
        } else {
          stateName = toState.data && toState.data.goalNotRequired === true ? undefined : 'page.lti.welcome';
        }
        return stateName === undefined ? true : transition.router.stateService.target(stateName);
      });
  }

  getRedirectStateForOneClickFlow(transition: Transition): TargetState {
    const fromParams = transition.params('from');
    const isRedirect = transition.to().name === 'page.lti.create-portfolio' ||
      transition.to().name === 'page.lti.one-click-portfolio';
    if (fromParams['actionType'] === 'complete' && isRedirect) {
      return  transition.router.stateService.target('page.home.goal-assist');
    }
  }
}
